import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { CurrentUserService } from 'services/currentUser';
import { ModalService } from 'common/source/services/modal';
import * as _ from 'lodash';
import { ITimeoutService } from 'angular';
import { HippoApiService } from 'services/hippoApi';

// TODO: make tests

const module = angular.module('update-escrow-lender', []);

interface UpdateEscrowLenderController extends angular.IStrictController {
    data: UpdateEscrowLenderOptions;
    policyInfo: CustomerPolicyInfo;
    escrowDetails: EscrowDetails;
    save: () => void;
    close: () => void;
}

interface EscrowPaymentMethodScope extends angular.IScope {
    escrowForm: angular.IFormController;
}

interface UpdateEscrowLenderOptions {
    preValidate: boolean;
}

const emptyEscrowDetails = {
    loan_number: '',
    lender_name: '',
    lender_mailing_address: {
        city: '',
        state: '',
        street: '',
        street2: '',
        zip: ''
    }
};

module.component('updateEscrowLender', {
    template: template,
    bindings: {
        data: '<'
    },
    controller: function(
        this: UpdateEscrowLenderController,
        $stateParams: PolicyStateParams,
        currentUserService: CurrentUserService,
        modalService: ModalService,
        hippoApiService: HippoApiService,
        $timeout: ITimeoutService,
        $rootScope: angular.IRootScopeService,
        $element: angular.IAugmentedJQuery
    ) {
        'ngInject';

        this.$onInit = () => {
            const policyIndex = $stateParams.policyIndex;

            currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                this.policyInfo = policyInfo;
                updateDisplay();
                if (this.data.preValidate) {
                    const formScope = $element.find('form').scope() as EscrowPaymentMethodScope;
                    formScope.escrowForm.$setSubmitted();
                }
            });
        };

        this.$onChanges = (changesObj) => {
            const policyInfo = changesObj.policyInfo;
            if (policyInfo && policyInfo.currentValue !== undefined) {
                $timeout(() => {
                    this.policyInfo = policyInfo.currentValue;
                    updateDisplay();
                });
            }
        };

        const updateDisplay = () => {
            this.escrowDetails = {
                ...emptyEscrowDetails,
                lender_mailing_address: {
                    ...this.policyInfo.checkout_data.lender_mailing_address
                } as LenderMailingAddress,
                lender_name: this.policyInfo.checkout_data.lender_name || '',
                loan_number: this.policyInfo.checkout_data.loan_number || ''
            };
        };

        this.save = () => {
            const policyId = this.policyInfo.id;
            const policyInfoUpdate: CustomerPolicyInfoUpdate = {
                checkout_data: {
                    payment_method: 'escrow',
                    lender_name: this.escrowDetails.lender_name,
                    loan_number: this.escrowDetails.loan_number,
                    lender_mailing_address: {
                        ...this.escrowDetails.lender_mailing_address
                    }
                }
            };

            hippoApiService.updateCustomerPolicy(policyId, policyInfoUpdate).then(() => {
                currentUserService.getUpdatedCustomerPolicyInfos().then(() => {
                    $rootScope.$emit('updatedCustomerPolicyInfos');
                });
                modalService.closeAllDialogs();
            });
        };

        this.close = () => {
            modalService.closeAllDialogs();
        };
    }
});

export { module };
